import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    addButtonYellow: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navCompanyContextActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navCompanyContextActions,
        color: palette.white,
      },
    },
    addButtonGreen: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navAdminActions,
        color: palette.white,
      },
    },
    addButtonBlue: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navOperatorActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navOperatorActions,
        color: palette.white,
      },
    },
    addButtonGray: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navSuperAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navSuperAdminActions,
        color: palette.white,
      },
    },
    nameContent: {
      fontSize: 12,
      paddingLeft: '16px !important',
    },

    addButtonIcon: {
      fontSize: '20px !important',
      '& .MuiButton-startIcon': {
        marginRight: 2,
      },
    },

    textAndIcon: {
      color: palette.darkGray,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      whiteSpace: 'nowrap',
      marginRight: 10,
      paddingLeft: 16,

      '& svg': {
        fontSize: 15,
      },
    },
    icons: {
      display: 'flex',
      '& svg': {
        fontSize: 15,
      },
    },
    partnerName: {
      color: palette.darkGray,
      paddingLeft: 16,
      fontSize: 12,
      whiteSpace: 'nowrap',
    },
    menuOptions: {
      fontSize: 12,
      fontWeight: 500,
    },
    centerFields: {
      textAlign: 'center',
      fontSize: 12,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
    },
    accessButtonHeader: {
      width: 40,
      fontSize: 12,
      color: palette.darkGray,
    },

    virtualizerField: {
      color: palette.darkGray,
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',

      '& .MuiGrid-root': {
        justifyContent: 'center',
      },
    },
    dateField: {
      color: palette.darkGray,
      whiteSpace: 'nowrap',
    },
    uuidField: {
      color: palette.darkGray,
      whiteSpace: 'nowrap',
    },
    summaryRowTable: {
      backgroundColor: `${palette.white} !important`,
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: 0,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'default',
      },
    },
    envRow: {
      backgroundColor: `${palette.lightYellow} !important`,
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: 0,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    envRowDirect: {
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: 0,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'pointer',
      },
    },
  });
